export default function formatDate(date) {
  const formaValue = date.toLocaleDateString('en-US', {
  });
  return formaValue;
}
